module.exports = __webpack_public_path__ + "img/wp-new-habit-card30.afe2788a.jpg";